import { render, staticRenderFns } from "./splashScreen.vue?vue&type=template&id=71257156&scoped=true&"
import script from "./splashScreen.vue?vue&type=script&lang=js&"
export * from "./splashScreen.vue?vue&type=script&lang=js&"
import style0 from "./splashScreen.vue?vue&type=style&index=0&id=71257156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71257156",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
